exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "* {\n    padding: 0;\n    margin: 0;\n  }\n  \n  body {\n    font-size: 14px;\n    color: #4a4a4a;\n    font-family: PingFangSC-Light; /*苹果设计的一款全新的中文系统字体，该字体支持苹果的动态字体调节技术*/\n  }\n  \n  ul {\n    list-style: none;\n  }\n  \n  a {\n    text-decoration: none;\n  }", "", {"version":3,"sources":["/var/jenkins_home/workspace/devops-aliyun/tsmart/A28_web_front_site_prod_cn/site-front/static/global/global.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,UAAU;GACX;;EAED;IACE,gBAAgB;IAChB,eAAe;IACf,8BAA8B,CAAC,qCAAqC;GACrE;;EAED;IACE,iBAAiB;GAClB;;EAED;IACE,sBAAsB;GACvB","file":"global.css","sourcesContent":["* {\n    padding: 0;\n    margin: 0;\n  }\n  \n  body {\n    font-size: 14px;\n    color: #4a4a4a;\n    font-family: PingFangSC-Light; /*苹果设计的一款全新的中文系统字体，该字体支持苹果的动态字体调节技术*/\n  }\n  \n  ul {\n    list-style: none;\n  }\n  \n  a {\n    text-decoration: none;\n  }"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--6-1!./node_modules/postcss-loader/lib??ref--6-2!./static/global/global.css
// module id = ILkX
// module chunks = 1